module.exports = __webpack_public_path__ + "img/bg_dress_shop.94584ff6.jpg";